import filter from 'lodash/fp/filter';
import find from 'lodash/fp/find';
import flow from 'lodash/fp/flow';
import isEmpty from 'lodash/isEmpty';
import { createSelector } from 'reselect';

import { getCurrentWorkbook } from '../entity/selectors/workbook-selectors';
import { hasClickAwayOnly } from '../user/selectors/user-selectors';
import { AppStoreState, ProductCopyrightTerms } from 'types';

const suppressedExpiration = license => supressedExpiration =>
  !!find({ productCurriculumId: license.productCurriculumId })(supressedExpiration);

export const isShowClickAwayAlert = createSelector(
  (state: AppStoreState, routeParams: any) => getCurrentWorkbook(state, routeParams),
  (state: AppStoreState, routeParams: any) => hasClickAwayOnly(state, routeParams),
  (state: AppStoreState) => state.user.licenses,
  (state: AppStoreState) => state.messaging.dismissedClickAwayAlerts,
  (currentWorkbook, hasClickAwayOnly, licenses, dismissedClickAwayAlerts) => {
    if (!hasClickAwayOnly) {
      return false;
    }
    return isEmpty(
      filter(productCurriculumId =>
        licenses.map(license => license.productCurriculumId).includes(productCurriculumId)
      )(dismissedClickAwayAlerts)
    );
  }
);

export const isShowLicenseExpirationAlert: any = createSelector(
  (state: AppStoreState) => state.user.licenses,
  (state: AppStoreState) => state.user.settings?.suppressedExpirationAlerts || [],
  (userLicenses, suppressedExpirationAlerts) =>
    !isEmpty(
      flow(
        filter((license: any) => license.expired),
        filter(license => !suppressedExpiration(license)(suppressedExpirationAlerts))
      )(userLicenses)
    ) && isEmpty(flow(license => !license.expired)(userLicenses))
);

export const isShowTermsConditionsCheckbox = createSelector(
  (state: AppStoreState) => state.entity.copyrightTerms || {},
  copyrightTerms => Object.keys(copyrightTerms).length
);

export const isCopyrightTermsViewed = createSelector(
  (state: AppStoreState, routeParams: any) => getCurrentWorkbook(state, routeParams),
  (state: AppStoreState, routeParams: any) => hasClickAwayOnly(state, routeParams),
  (state: AppStoreState) => state.entity.copyrightTerms,
  (currentWorkbook, isClickAwayOnly, copyrightTerms = {}) => {
    if (!currentWorkbook.products) return false;
    const [{ productCurriculumId }] = currentWorkbook.products;
    const productCopyrightTerms: ProductCopyrightTerms = Object.values(copyrightTerms).find(
      (copyrightTerm: any) => copyrightTerm.productCurriculumId === productCurriculumId
    ) as any;
    return !isClickAwayOnly && !!productCopyrightTerms;
  }
);
